import {useLayoutEffect, useState} from "react";

const QUERY = '(max-width: 450px)';
const getMatches = () => window.matchMedia(QUERY).matches;

export const useIsMobile = () => {
    const [matches, setMatches] = useState<boolean>(() => getMatches());

    const handleChange = () => {
        setMatches(getMatches());
    }

    useLayoutEffect(() => {
        const matchMedia = window.matchMedia(QUERY);

        handleChange();

        if(matchMedia.addEventListener) {
            matchMedia.addEventListener('change', handleChange);
        } else {
            matchMedia.addListener(handleChange);
        }

        return () => {
            if(matchMedia.removeEventListener) {
                matchMedia.removeEventListener('change', handleChange);
            } else {
                matchMedia.removeListener(handleChange);
            }
        }
    }, []);

    return matches;
}